import React, { useState, useEffect } from 'react';
import CookieConsent from 'react-cookie-consent';
import InputForm from './components/InputForm';
import ResultList from './components/ResultList';
import Loading from './components/Loading';
import Footer from './components/Footer';
import axios from 'axios';
import Alert from 'react-bootstrap/Alert';
import { Card } from 'primereact/card';

import "primereact/resources/themes/lara-light-cyan/theme.css";
import { Dialog } from 'primereact/dialog';

import './App.css';
import './styles.css';

//const BASE_URL = 'https://adjudicamap.mynookapp.es/';
//const isOriginUrlCorrect = await axios.post(${BASE_URL}/check-origin-validity, { origin: origin.address });

const App = () => {
    const [codes, setCodes] = useState('');
    const [origin, setOrigin] = useState({ address: '', valid: false, checked: false, reformatted: false });
    const [newOriginAddress, setNewOriginAddress] = useState('');
    const [results, setResults] = useState([]);
    const [travelTimes, setTravelTimes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [transportModes, setTransportModes] = useState({
        walking: true,
        driving: true,
        biking: true,
        transit: true,
    });
    const [showReformattedAddressAlert, setShowReformattedAddressAlert] = useState(false);
    const [showCenterLimitAlert, setShowCenterLimitAlert] = useState(false);
    const [searchAttempted, setSearchAttempted] = useState(false);
    const CENTER_LIMIT_SEARCH = 200;
    
    const config = require('./config.js');
    const BASE_URL = config.BASE_URL;
    
    // Estado para el modal
    const [showModal, setShowModal] = useState(false);
    const [invalidCodes, setInvalidCodes] = useState([]); // Códigos no encontrados
    useEffect(() => {
        // Verificar si el usuario ya aceptó las cookies
        const consent = localStorage.getItem("cookiesAccepted");
        if (consent === "true") {
            loadGoogleAnalytics();
        }
    }, []);

    const loadGoogleAnalytics = () => {
        if (!window.gtag) {
            // Agregar script de Google Analytics
            const scriptTag = document.createElement("script");
            scriptTag.async = true;
            scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=G-ZKJYWSDBM2`
            document.head.appendChild(scriptTag);

            // Configurar Google Analytics
            const scriptInline = document.createElement("script");
            scriptInline.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', 'G-ZKJYWSDBM2');
            `;
            document.head.appendChild(scriptInline);
        }
    };

    // Automatically hide the alert after 5 seconds when it is shown
    useEffect(() => {
        if (origin.reformatted) {
            const timer = setTimeout(() => {
                setShowReformattedAddressAlert(false);  // This triggers the fade-out effect
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [origin.reformatted]); // Re-run the effect when origin.reformatted changes

    // Fetch results from the backend
    const fetchResults = async () => {
        setLoading(true);
        setSearchAttempted(true);
        setResults([]);

        try {

            // Check if origin is correct
            const isOriginUrlCorrect = await axios.post(`${BASE_URL}check-origin`, { origin: origin.address });
            const isValid = isOriginUrlCorrect.data.isValid.status === 'valid';

            const reformattedAddress = isOriginUrlCorrect.data.isValid.address;
            setNewOriginAddress(reformattedAddress);

            // Update origin states together
            setOrigin({
                address: reformattedAddress,
                valid: isValid,
                checked: true,
                reformatted: reformattedAddress !== origin.address,
            });

            if(reformattedAddress !== origin.address) setShowReformattedAddressAlert(true);

            if (isValid){
                const response = await axios.post(`${BASE_URL}get-centers`, { codes });
                let centers = response.data.centers || [];

                // Check if limit reached, then reduce if necessary
                if(centers.length > CENTER_LIMIT_SEARCH){
                    centers = centers.slice(0, CENTER_LIMIT_SEARCH);
                    setShowCenterLimitAlert(true);
                }
                const notFoundCodes = response.data.notFoundCodes || [];
                setResults(centers);
    
                // Mostrar modal si hay códigos no encontrados
                if (notFoundCodes.length > 0) {
                    setInvalidCodes(notFoundCodes);
                    setShowModal(true);
                }

                if (centers.length > 0) {
                    const travelResponse = await axios.post(`${BASE_URL}travel-times`, {
                        origin: reformattedAddress,
                        centers,
                        modes: Object.keys(transportModes).filter((mode) => transportModes[mode]),
                      });                      
                    setTravelTimes(travelResponse.data.travelTimes || []);
                }
            }

        } catch (error) {
            console.error('Error al conectar con el backend:', error);
        }

        setLoading(false);

    };

  const handleCenterLimitAlertClose = () => {
    setShowCenterLimitAlert(false); // This hides the alert
  };

    // Reset the form to initial state
    const resetForm = () => {
        setCodes('');
        setOrigin({ address: '', valid: false, checked: false, reformatted: false });
        setResults([]);
        setTravelTimes([]);
        setTransportModes({
            walking: true,
            driving: true,
            biking: true,
            transit: true
        });
        setSearchAttempted(false);
        setLoading(false);
    };

    return (
        <div className="container">
            {/* Banner de cookies */}
             <CookieConsent 
                location="bottom"
                buttonText="Aceptar"
                declineButtonText="Rechazar"
                enableDeclineButton
                onAccept={() => {
                    localStorage.setItem("cookiesAccepted", "true");
                    loadGoogleAnalytics();
                }}
                onDecline={() => {
                    localStorage.setItem("cookiesAccepted", "false");                  
                }}
                style={{ background: "#222", color: "#fff" }}
                buttonStyle={{ background: "#4caf50", color: "#fff", fontSize: "14px" }}
                declineButtonStyle={{ background: "#f44336", color: "#fff", fontSize: "14px" }}
            >
                Esta web usa cookies para mejorar la experiencia del usuario.{" "}
                <a href="/politica-de-privacidad" style={{ color: "#4caf50" }}>Leer más</a>
            </CookieConsent>
            
            <div className="row">
                <div className="col-md-6 offset-md-3 col-sm-10 offset-sm-1">
                    <Card className="min-w-460">
                        <div className="row">
                            <div className="col-12 header-div-style">
                                <img src="/LogoAdjudicaMAP.png" alt="Logo" width="100" height="100" />
                                <h2 className="header-style">
                                    Adjudica<span style={{ color: '#28b463' }}>Map</span>
                                </h2>
                            </div>
                        </div>
                
                        <InputForm
                            codes={codes}
                            setCodes={setCodes}
                            origin={origin}
                            setOrigin={setOrigin}
                            transportModes={transportModes}
                            setTransportModes={setTransportModes}
                            onSearch={fetchResults} // Pass fetchResults function
                            onReset={resetForm}     // Pass resetForm function
                        />

                        <Alert className="m-t-10" show={showCenterLimitAlert} variant="warning" dismissible onClose={handleCenterLimitAlertClose}>
                            <p>Has alcanzado el límite de centros disponibles. El número de centros ha sido reducido a {CENTER_LIMIT_SEARCH}.</p>
                            <p>Para consultar el resto de centros tendrás que realizar otra consulta.</p>
                        </Alert>

                        {origin.reformatted && origin.valid &&
                            <Alert className="m-t-10" show={showReformattedAddressAlert} variant="warning" dismissible>    
                                <p>La dirección de origen ha sido reformulada a: {newOriginAddress}</p>
                            </Alert>
                        }
                    </Card>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    {loading ? (
                    <Loading text="Cargando tabla, por favor espera..." gifPath="/ducking.gif" />
                ) : (
                    searchAttempted &&
                    origin.checked &&
                    origin.valid && <ResultList results={results} travelTimes={travelTimes} />
                )}

                </div>
            </div>

            <div className="row">
                <div className="col-md-6 offset-md-3 col-sm-10 offset-sm-1">
                    <Footer/>
                </div>
            </div>

            <Dialog header="Códigos no encontrados" visible={showModal} draggable={false} style={{ width: '30vw' }} onHide={() => {if (!showModal) return; setShowModal(false); }}>
                <p>Los siguientes códigos no están en la base de datos: <b> {invalidCodes.join(', ')} </b></p>
                <p style={{ marginTop: '10px' }}>
                    Si crees que debería estar registrado o deseas añadirlo, por favor contáctanos a <a href="mailto:contacto@mynookapp.es">contacto@mynookapp.es</a> y estaremos encantados de ayudarte.
                </p>
            </Dialog>
        </div>
    );
};

export default App;
